module.exports = __webpack_public_path__ + "media/components/src/assets/images/method/cs-img-a98d614ef7a6e25ec0384e1fd3d2ae5f.png";